import React, { useCallback, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { ChevronRight, ChevronDown, Search, Info, Copy, Upload, CheckCircle } from "lucide-react";
import storage from "../../../../Storage";
import C from "../../../../Constant";
import coins from "../../../coins";
import socket from "../../../../Socket";
import { Col, Row, Dropdown } from "react-bootstrap";
import {
  __, wait, decode, encode, forceSatoshiFormat, Event,
  isMobile,
  sendNotfication,
  getUID, API,
} from '../../../../Helper';
import axios from 'axios';
import { QRCode } from 'react-qrcode-logo';
import Storage from '../../../../Storage';
const Container = styled.div`
  padding: 8px;
  color: #ffffff;
   @media (max-width: 768px) {
     padding: 0px;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
  flex:1;
`;

const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding:6px 10px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
`;

const DropdownPanel = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background:#1B2326;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-top: 4px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
  padding: 10px 12px;
  
  @media (max-width: 768px) {
    max-height: 300px;
    position: absolute;
    width: 100%;
    z-index: 1001; /* Higher z-index to ensure visibility */
  }
`;

const QRCodeContainer1 = styled.div`
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  padding: -6px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  margin-top: 12px;
  
  @media (max-width: 768px) {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 6px 12px 6px 40px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  &::placeholder {
    color: #fff;
    opacity: 0.6;
  }
  
  @media (max-width: 768px) {
    padding: 6px 8px 6px 36px;
    font-size: 14px;
  }
`;

const Input = styled.input`
flex:1;
  padding:6px 10px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  &::placeholder {
    color: #fff;
    opacity:0.6;
  }
`;
const DepositButton = styled.div`
  
  margin-top: auto;
flex:1;
padding:7px 9px;
  display:flex;
  justify-content:center;
  align-items:center;
   background: #25ee89;
  color: black !important;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;
const GetButton = styled.div`
  flex:1;
  margin-top: 1px;
  padding: 8px 12px;
  display:flex;
  justify-content:center;
  align-items:center;
   background: #25ee89;
  color: black !important;
  border: none;
   border-radius: 8px;
width:100%;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;
const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 49%;
  transform: translateY(-50%);
  color: #fff;
`;

const CoinOption = styled.div`
  display: flex;
  align-items: center;
  padding: 14px;
  cursor: pointer;
  border-radius: 12px;
  &:hover {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
  }
  ${props => props.isSelected && `
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
  `}
  
  @media (max-width: 768px) {
    padding: 10px;
    margin-bottom: 4px;
  }
`;

const CoinImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 12px;
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`;

const CoinName = styled.div`
  font-size: 16px;
  font-weight: bold;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const CoinName1 = styled.div`
  font-size: 16px;
  font-weight: bold;
   @media (max-width: 768px) {
   margin-left: -16px;
     font-size: 10px;
     text-wrap:no-wrap;
  }
 
`;

const CoinBalance = styled.span`
  margin-left: auto;
  color: #8E9293;
   display:none;
`;


// const CoinName = styled.span`
//   font-size: 16px;
//   font-weight: 500;
// `;

const TokenListContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
    @media (max-width: 768px) {
  gap: 4px;
  margin-top: 4px;
  }
`;

const TokenButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
   background: #1B2326;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  transition: background 0.2s ease;
  &:hover {
     background: #1B2326;
  }
        @media (max-width: 768px) {
 gap: 4px;
  padding: 4px 8px;
  }
`;

const TokenIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
          @media (max-width: 768px) {
      
width: 18px;
  height: 18px;

  }
  
`;

const TokenName = styled.div`
  font-size: 14px;
  font-weight: 500;
      @media (max-width: 768px) {
   font-size: 12px;
  }
`;

const MoreButton = styled(TokenButton)`
  padding: 8px 12px;
    @media (max-width: 768px) {
    padding: 4px 8px;
  }

`;

const NoteContainer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px auto 16px;
  border-left: 3px solid #FF9D02;
`;

const NoteText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

const NoteIcon = styled(Info)`
  color: #FF9D02;
  flex-shrink: 0;
`;

const FooterText = styled.div`
  color: #ffffff;
  margin: 18px 0;
`;

const AddLink = styled.span`
  color: #20EE89;
  cursor: pointer;
`;




const Label = styled.div`
  color: #ffff;
  font-size: 14px;
  
   @media (max-width: 768px) {
    text-align:center;
  }
`;







const CodeContainer = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap:4px;
  margin: 12px 0px;
`;
const WarningContainer = styled.div`
   background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;s
  margin: 0 auto;
  margin-bottom: 16px;
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const WarningText = styled.span`
  color: #ffff;
  font-size: 14px;
  font-weight: 500;
`;

const BonusContainer = styled.div`
  background-color: rgba(180, 155, 100, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px auto;
  margin-bottom: 16px;
`;

const IconWrapper1 = styled.div`
  width: 28px;
  height: 28px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Container1 = styled.div`
  max-width: 400px;
  width: 100%;
`;

const BonusButton = styled.button`
  width: 100%;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  text-align: left;
  font-weight: 500;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;
  }
`;

const RadioContainer = styled.div`

  border-radius: 8px;
  display: flex;
  flex-direction:column;
  gap: 6px;
  width:100%;
  margin:12px 0px;
`;

const Label3 = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
`;

const RadioWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const CustomRadio = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  transition: all 0.2s;                                    
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${HiddenRadio}:checked + & {
    border-color: #41ED84;
  }

  &:after {
    content: '';
    position: absolute;
    display: none;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: #41ED84;
    
    ${HiddenRadio}:checked ~ & {
      display: block;
    }
  }
`;
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const BaseText = styled.span`
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
`;

const HighlightedText = styled(BaseText)`
  color: #25ee89;
`;
const Text = styled.span`
  font-weight: 500;
  text-wrap:no-wrap;
`;

const Container5 = styled.div`
  display: flex;
  gap: 16px;
  // padding: 16px;
  border-radius: 8px;
  width: 100%;
  margin:12px 0px;

   @media (max-width: 768px) {
     gap: 6px;
     align-items:center;
  }
  

`;

const QRCodeContainer = styled.div`
 width:100%;
  border-radius: 4px;
  overflow: hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  
  img {
    width: 120px;
  height: 120px;
    object-fit: contain;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  width: 67%;
  display: flex;
  flex-direction: column;
  gap: 10px;
    @media (max-width: 768px) {
      width: 61%;
  }
`;

const Label4 = styled.div`
  color: #9ba1a6;
  font-size: 14px;

`;

const AddressContainer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-radius: 6px;
  width: 100%;
  color: #fff;
  font-family: monospace;
  font-size: 14px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0; // Important for text truncation
    margin-top:-12px;
  }
`;

const CopyButton = styled.div`
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  border: none;
  // flex:1;
  // width:100%;
  // padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  // margin-right:auto;
  display: flex;
  text-align:center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: background-color 0.2s;
  white-space: nowrap;
  width: fit-content;
  
  // &:hover {
  //   background-color: #4c5256;
  // }
`;

const CopyIcon = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: currentColor;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' /%3E%3C/svg%3E");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
`;




// Add new styled components for the form
const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 0px;
`;

const TransactionForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
`;

const FileUploadContainer = styled.div`
  border: 2px dashed #41ED84;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    border-color: #20EE89;
  }
`;

const UploadText = styled.div`
  color: #ffffff;
  margin-top: 8px;
  font-size: 14px;
`;
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;
const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2;
`;

const Spinner = styled.div`
  width: 2rem;
  height: 2rem;
  border: 3px solid #e5e7eb;
  border-top-color: #ab1ac6;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.span`
  color: #ab1ac6;
  font-size: 1rem;
  margin-left: 0.75rem;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
const PaymentMethodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

const MethodSelector = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;


const MethodButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid ${props => props.selected ? '#E5E7EB' : '#25ee89'};
  background: ${props => props.selected ? '#25ee89' : '#25ee89'};
  color: ${props => props.selected ? '#292d2e' : '#374151'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.selected ? '#25ee89' : '#25ee89'};
  }
`;

// Container for the transaction form
const TransactionFormContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  margin-top: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

// Error message styling
const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
`;

// Form group for each input field
const FormGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: a8px;
    font-weight: 500;
    color: #424242;
  }
  
  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #2196f3;
      box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
    }
    
    &::placeholder {
      color: #9e9e9e;
    }
  }
`;

// Container for buttons
const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

// Base button style
const Button = styled.button`
  padding: 12px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
`;

// Submit button
const SubmitButton = styled(Button)`
  background-color: #2196f3;
  color: white;
  border: none;
  
  &:hover {
    background-color: #1976d2;
  }
`;

// Cancel button
const CancelButton = styled(Button)`
  background-color: white;
  color: #616161;
  border: 1px solid #e0e0e0;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;
// Deposit button
const cryptoOptions = [
  { id: 'dot', name: 'DOT', iconClass: 'dot' },
  { id: 'link', name: 'LINK', iconClass: 'link' },
  { id: 'dai', name: 'DAI', iconClass: 'dai' },
  { id: 'usdc', name: 'USDC', iconClass: 'usdc' },
  { id: 'xmr', name: 'XMR', iconClass: 'xmr' },
];

const tokens = [
  { id: 'eth', name: 'ETH', icon: '/assets/images/eth.png' },
  { id: 'btc', name: 'BTC', icon: '/assets/images/btc.png' },
  { id: 'usdt', name: 'USDT', icon: '/assets/images/usdt.png' },
  // { id: 'usdc', name: 'USDC', icon: '/assets/images/USDC.png' },
  { id: 'doge', name: 'DOGE', icon: '/assets/images/DOGE.png' },
];

const SkylaDepositModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenNetwork, setIsOpenNetwork] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedNetwork, setSelctedNetwork] = useState("")
  const [selectedBank, setSelectedBank] = useState("Bank Of Maldives")
  const [error, setError] = useState("");
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [placeholder, setPlaceholder] = useState("");
  // Check if user is admin-created (has numeric parent_id that isn't 1/SuperAdmin)
  const parentId = Storage.getKey('parent_id');
  const isAdminCreatedUser = parentId && parentId !== "orphan" && parentId !== "1" && !isNaN(Number(parentId));
  // Coin and credit state
  const [credits, setCredits] = useState({});
  const [selectedCoin, setSelectedCoin] = useState(Storage.getKey('coin'));
  const [activeCoins, setActiveCoins] = useState(
    storage.getKey('active_coins')?.split(',').map(String) || ['1']
  );


  const [selectedPayment, setSelectedPayment] = useState("Bank Transfer")

  // Main component state
  const [state, setState] = useState({
    currentCoin: storage.getKey('coin') || "BTC",
    credits: {},
    list: [],
    content: [],
    wallet: "btc",
    deposit: true,
    slide: false,
    height: 573,
    margin: "mt-1",
    amount: "",
    coinId: "",
    networks: [],
    selectedNetwork: "",
    qrString: "",
    coinName: "",
    logoUrl: "",
    isLoading: false,
    isCopied: false,
    depositAddress: "",
    depositAmount: "",
    showDepositDetails: false,
    iframeUrl: '', // New state for iframe URL
    showIframe: false // New state to toggle iframe visibility
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [paymentMode, setPaymentMode] = useState('automatic');
  const [bankDetailsList, setBankDetailsList] = useState([]);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [selectedUPI, setSelectedUPI] = useState('UPI1');
  const [bankDetails, setBankDetails] = useState([]);
  const [copied, setCopied] = React.useState(false);
  const address = "0x5e6E82fc1117AE06c8b1230164284Ec5d0141Df";
  const [isOpenBonus, setIsOpenBonus] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('automatic');
  const [copiedStates, setCopiedStates] = useState({
    accountName: false,
    accountNumber: false,
    ifscCode: false
  });

  const deposits = [
    "1st Deposit Bonus",
    "2nd Deposit Bonus",
    "3rd Deposit Bonus",
    "4th Deposit Bonus"
  ];
  const bankDeatils = [
    "Bank Of Maldives",
    "Commercial Bank of Maldives"
  ]
  const getbankImage = (i) => {
    if (i === "Bank Of Maldives") {
      return "/assets/images/bom.png"
    }
    else {
      return "/assets/images/CBM.jpg"
    }
  }

  const paymentDetails = [
    "Bank Transfer",
    "UPI ID",
    "Google Pay"
  ];


  // Fetch bank details when selectedCoin changes (for fiat currencies)
  // useEffect(() => {
  //   if (isFiatCurrency(selectedCoin)) {
  //     fetchBankDetails();
  //   }
  // }, [selectedCoin]);
  useEffect(() => {
    if (isFiatCurrency(selectedCoin)) {
      fetchBankDetails();
    }
  }, [selectedCoin]);

  useEffect(() => {
    if (state.currentCoin === "MVR") {
      setPlaceholder("Enter Deposit Amount (Minmim 100MVR)")
    }
    else {
      setPlaceholder("Enter Deposit Amount")
    }
  }, [state.currentCoin])
  // Function to fetch bank details from API
  // const fetchBankDetails = async () => {
  //   try {
  //     const response = await fetch(`${API}/bankDetails/${selectedCoin}`);
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch bank details');
  //     }
  //     const data = await response.json();
  //     setBankDetails(data);

  //     // Set first bank as default if available
  //     if (data.length > 0) {
  //       setSelectedBank(data[0].bank_name);
  //       setSelectedBankDetails({
  //         accountName: data[0].account_holder_name,
  //         accountNumber: data[0].account_number,
  //         ifscCode: data[0].ifsc_code,
  //         upiId: data[0].upi_id
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching bank details:', error);
  //     setError('Failed to load bank details. Please try again.');
  //   }
  // };
  const fetchBankDetails = async () => {
    try {
      const userId = getUID();
      const url = userId 
        ? `${API}/bankDetails/user/${selectedCoin}/${userId}`
        : `${API}/bankDetails/${selectedCoin}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to fetch bank details');
      }
      const data = await response.json();

      if (selectedCoin === "INR") {
        // If INR, filter only UPI details
        setBankDetails(data.filter(bank => bank.upi_id));
      } else {
        setBankDetails(data);
      }

      if (data.length > 0) {
        setSelectedBank(data[0].bank_name);
        setSelectedBankDetails({
          accountName: data[0].account_holder_name,
          accountNumber: data[0].account_number,
          ifscCode: data[0].ifsc_code,
          upiId: data[0].upi_id,
          qr_image: data[0].qr_image
        });
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
      setError('Failed to load bank details. Please try again.');
    }
  };



  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setScreenshot(file);
      setError("");
    }
  };

  // Handle bank selection
  const handleBankSelect = (bankName) => {
    setSelectedBank(bankName);
    const bank = bankDetails.find(b => b.bank_name === bankName);
    if (bank) {
      setSelectedBankDetails({
        accountName: bank.account_holder_name,
        accountNumber: bank.account_number,
        ifscCode: bank.ifsc_code,
        upiId: bank.upi_id,
        qr_image: bank.qr_image
      });
    }
    setIsOpenNetwork(false);
  };

  // Handle copy functionality
  const handleCopyAddress = (field, value) => {
    navigator.clipboard.writeText(value);
    setCopiedStates(prev => ({
      ...prev,
      [field]: true
    }));

    setTimeout(() => {
      setCopiedStates(prev => ({
        ...prev,
        [field]: false
      }));
    }, 2000);
  };
  useEffect(() => {
    // Reset all form-related states
    setError("");
    setShowTransactionForm(false);
    setTransactionId("");
    setScreenshot(null);
    setState(prev => ({ ...prev, amount: "", isLoading: false }));
  }, [selectedCoin]); // Dependency on selectedCoin


  const renderPayment = () => {
    return (
      <>
        {selectedPayment === "Bank Transfer" && (
          <>
            <AddressContainer>
              <span>Account Holder Name: {bankDetails.accountName}</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', bankDetails.accountName)}
                copied={copiedStates.accountName}
              >
                {copiedStates.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
            <AddressContainer>
              <span>Account Number: {bankDetails.accountNumber}</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountNumber', bankDetails.accountNumber)}
                copied={copiedStates.accountNumber}
              >
                {copiedStates.accountNumber ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates.accountNumber ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
            <AddressContainer>
              <span>IFSC Code: {bankDetails.ifscCode}</span>
              <CopyButton
                onClick={() => handleCopyAdress('ifscCode', bankDetails.ifscCode)}
                copied={copiedStates.ifscCode}
              >
                {copiedStates.ifscCode ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates.ifscCode ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

        {selectedPayment === "UPI Number" && (
          <>
            <AddressContainer>
              <span>UPI Number: 993939393</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', 993939393)}
                copied={copiedStates.accountName}
              >
                {copiedStates.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

        {selectedPayment === "UPI ID" && (
          <>
            <AddressContainer>
              <span>UPI Number: 993939393@upi</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', '993939393@upi')}
                copied={copiedStates.accountName}
              >
                {copiedStates.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

      </>
    )
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(state.depositAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    sendNotfication("copied", "success", "bottom-left", true);
  };
  const handleCopyAdress = async (field, value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedStates(prev => ({ ...prev, [field]: true }));

      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopiedStates(prev => ({ ...prev, [field]: false }));
      }, 2000);
      sendNotfication("copied", "success", "top-right");
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };



  // Utility Functions
  const getCoinNameByNetwork = useCallback((network, coinInfo, defaultCoin) => {
    if (networkCoinMap[network]) {
      return networkCoinMap[network];
    }
    if (coinInfo && coinInfo.id) {
      return coinInfo.id;
    }
    return defaultCoin.toLowerCase();
  }, []);

  // Socket and Credit Management
  const getCreditAndCoins = useCallback((data) => {
    const { credit } = data;
    setState(prev => ({ ...prev, credits: credit }));
    setUpCoins();
  }, []);

  const getTextBonus = (i) => {
    if (i === 0) {
      return '180%'
    }
    else if (i === 1) {
      return '240%'
    }
    else if (i === 2) {
      return '300%'
    }
    else if (i === 3) {
      return '360%'
    }
  }

  const setUpCoins = useCallback(() => {
    if (isMobile()) {
      setState(prev => ({ ...prev, height: 685, margin: "mt-1" }));
    }

    const newList = coins.reduce((acc, item, i) => {
      if (item.preffix === "NC") return acc;

      const credit = forceSatoshiFormat(
        state.credits[__.lowerCase(item.preffix)]
      );

      const listItem = (
        <Dropdown.Item
          key={__.toString(i)}
          as="button"
          className="animated fadeIn"
          onClick={() => loadCoinId(item.preffix)}
        >
          <span>
            <img
              src={`/assets/images/${item.image}`}
              className="mr-1 img-fluid mini-coin"
              alt="Coin"
            />
            {item.preffix}
          </span>
        </Dropdown.Item>
      );

      return [...acc, listItem];
    }, []);

    setState(prev => ({ ...prev, list: newList }));
  }, [state.credits, isMobile]);

  // Archive Management
  const showArchive = useCallback(() => {
    if (state.slide) Event.emit("deposit_archive_back");

    setState(prev => ({ ...prev, slide: !prev.slide }));

    wait(300).then(() => {
      setState(prev => ({ ...prev, deposit: !prev.deposit }));
    });

    wait(300).then(() => {
      loadCoinId("BTC");
    });
  }, [state.slide]);

  // Coin Loading and Management
  const loadCoinId = useCallback(async (coin) => {

    const coinsList = [
      { id: "bitcoin", symbol: "BTC" },
      { id: "ethereum", symbol: "ETH" },
      { id: "tether-usdt", symbol: "USDT" },
      { id: "bitcoincash", symbol: "BCH" },
      { id: "litecoin", symbol: "LTC" },
      { id: "tron", symbol: "TRX" },
      { id: "dogecoin", symbol: "DOGE" },
      { id: "cardano", symbol: "ADA" },
      { id: "ripple", symbol: "XRP" },
      { id: "binancecoin", symbol: "BNB" },
      { id: "paxdollar", symbol: "USDP" },
      { id: "nexo", symbol: "NEXO" },
      { id: "maker", symbol: "MKR" },
      { id: "trueusd", symbol: "TUSD" },
      { id: "usdcoin", symbol: "USDC" },
      { id: "binanceusd", symbol: "BUSD" },
    ];

    console.log("coin name", coin)
    if (coin.toUpperCase() === 'INR') {
      console.log("Coin is INR, skipping loadCoinId process.");
      return;
    }

    setState(prev => ({
      ...prev,
      currentCoin: coin,
      coinId: "",
      networks: [],
      selectedNetwork: "",
      isLoading: true,
      coinName: "",
      logoUrl: ""
    }));

    console.log("coin", coin)

    try {
      const response = await axios.post(`${API}/getCoinDetails`, {
        symbol: coin.toUpperCase()
      });
      console.log("infor", response)
      const { coinId, networks, coinFullName, logoUrl } = response.data;
      let networksList = Object.keys(networks);

      // Sort networks to put TRX first
      const priorityNetworks = ['TRX', 'BSC', 'ETH'];
      networksList.sort((a, b) => {
        const aIndex = priorityNetworks.indexOf(a);
        const bIndex = priorityNetworks.indexOf(b);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return a.localeCompare(b);
      });

      console.log("netweok liss", networksList)

      const coinInfo = coinsList.find(item => item.symbol === coin.toUpperCase());
      let selectedNetwork = networksList[0] || "";
      // let coinName = coinInfo ? coinInfo.id : coin.toLowerCase();


      let coinName = coinInfo ? coinInfo.id : coin.toLowerCase();
      // // Special handling for USDT
      // if (coin.toUpperCase() === 'USDT') {
      //     networksList = ['ETH', 'TRX', 'BSC']; // Only allow these networks for USDT
      // }
      // Update coin name dynamically based on selected network for all coins
      switch (selectedNetwork) {
        case 'USDT':
          coinName = 'tether-usdt';
        case 'TRX':
          coinName = 'tron'; // For TRX network
          break;
        case 'BSC':
          coinName = 'binancecoin'; // For BSC network
          break;
        case 'ETH':
          coinName = 'ethereum'; // For ETH network
          break;
        case 'BTC':
          coinName = 'bitcoin'; // For BTC network
          break;
        case 'BCH':
          coinName = 'bitcoincash'; // For BCH network
          break;
        case 'ADA':
          coinName = 'cardano'; // For ADA network
          break;
        case 'XRP':
          coinName = 'ripple'; // For XRP network
          break;
        case 'DOGE':
          coinName = 'dogecoin'; // For DOGE network
          break;
        case 'LTC':
          coinName = 'litecoin'; // For LTC network
          break;
        case 'USDP':
          coinName = 'paxdollar'; // For USDP network
          break;
        case 'NEXO':
          coinName = 'nexo'; // For NEXO network
          break;
        case 'MKR':
          coinName = 'maker'; // For MKR network
          break;
        case 'TUSD':
          coinName = 'trueusd'; // For TUSD network
          break;
        case 'USDC':
          coinName = 'usdcoin'; // For USDC network
          break;
        case 'BUSD':
          coinName = 'binanceusd'; // For BUSD network
          break;
        default:
          coinName = coinInfo ? coinInfo.id : coin.toLowerCase(); // Fallback to default
          break;
      }


      console.log("network list", networksList);
      console.log("name", coinName)
      setSelctedNetwork(networksList[0])

      setState(prev => ({
        ...prev,
        coinId,
        networks: networksList,
        selectedNetwork,
        isLoading: false,
        coinName,
        logoUrl
      }));
    } catch (error) {
      console.error("Error fetching coin details:", error);
      // sendNotfication("Error fetching coin information", "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
    }
  }, [getCoinNameByNetwork]);


  const [ccInitiate, setCCInititate] = useState(false)
  // Payment Processing
  const initiateDeposit = async () => {
    if (!state.amount || state.amount <= 0) {
      sendNotfication("Please enter a correct amount.", "error", "top-right");
      return;
    }

    if (!selectedNetwork) {
      sendNotfication("Please Choose Network.", "error", "top-right");
      return;
    }
    setCCInititate(true)

    setState(prev => ({ ...prev, isLoading: true, qrString: "" }));
    const payload = {
      coinId: state.coinId,
      price: state.amount,
      orderId: `order${Date.now()}`,
      chain: selectedNetwork,
      generateCheckoutURL: true,
      returnUrl: "https://bkk07.com/",
      userid: getUID().toString()
    }

    console.log("paylod", payload)


    try {
      const response = await axios.post(`${API}/createDeposit`, payload

      );

      const { data } = response.data;

      if (data.address) {

        // Determine correct coin name based on the selected network
        let coinName;
        switch (state.selectedNetwork.toUpperCase()) {
          case 'USDT':
            coinName = 'tether-usdt';  // For TRX network
            break;
          case 'TRX':
            coinName = 'tron';  // For TRX network
            break;
          case 'ETH':
            coinName = 'ethereum';  // For ETH network
            break;
          case 'BSC':
            coinName = 'binancecoin';  // For BSC network
            break;
          case 'BTC':
            coinName = 'bitcoin';  // For BTC network
            break;
          case 'BCH':
            coinName = 'bitcoincash';  // For BCH network
            break;
          case 'ADA':
            coinName = 'cardano';  // For ADA network
            break;
          case 'XRP':
            coinName = 'ripple';  // For XRP network
            break;
          case 'DOGE':
            coinName = 'dogecoin';  // For DOGE network
            break;
          case 'LTC':
            coinName = 'litecoin';  // For LTC network
            break;
          case 'USDP':
            coinName = 'paxdollar';  // For USDP network
            break;
          case 'NEXO':
            coinName = 'nexo';  // For NEXO network
            break;
          case 'MKR':
            coinName = 'maker';  // For MKR network
            break;
          case 'TUSD':
            coinName = 'trueusd';  // For TUSD network
            break;
          case 'USDC':
            coinName = 'usdcoin';  // For USDC network
            break;
          case 'BUSD':
            coinName = 'binanceusd';  // For BUSD network
            break;
          default:
            coinName = state.coinName;  // Use current coin name if no match
            break;
        }

        console.log("data us", data)

        setState(prev => ({
          ...prev,
          depositAddress: data.address,
          depositAmount: state.amount,
          showDepositDetails: true,
          isLoading: false,
          qrString: `${data.address}`
        }));
      } else {
        sendNotfication("Deposit initiation failed", "error", "top-right");
        setState(prev => ({ ...prev, isLoading: false }));
        setCCInititate(false);
      }
    } catch (error) {
      console.error("Error initiating deposit:", error);
      sendNotfication("Error initiating deposit", "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
      setCCInititate(false);
    }
  };


  // Socket Connection Effect
  useEffect(() => {
    const token = storage.getKey('token');

    if (token) {
      socket.emit(C.CREDIT, encode({ coin: selectedCoin }));
    }

    const handleCreditData = (data) => {
      const decodedData = decode(data);
      const { credit } = decodedData;
      setCredits(credit);

      const currentCoin = __.lowerCase(selectedCoin);
      const currentCredit = forceSatoshiFormat(credit[currentCoin]);
      storage.setKey('credit', currentCredit);
    };

    const handleCreditUpdate = (data) => {
      const decodedData = decode(data);
      const { value, coin: updatedCoin } = decodedData;
      const formattedValue = forceSatoshiFormat(value);

      setCredits(prev => ({
        ...prev,
        [__.lowerCase(updatedCoin)]: value
      }));

      if (__.lowerCase(updatedCoin) === __.lowerCase(selectedCoin)) {
        storage.setKey('credit', formattedValue);
      }
    };

    socket.on(C.CREDIT, handleCreditData);
    socket.on(C.UPDATE_CREDIT, handleCreditUpdate);

    return () => {
      socket.off(C.CREDIT, handleCreditData);
      socket.off(C.UPDATE_CREDIT, handleCreditUpdate);
    };
  }, [selectedCoin]);

  // Initial Setup Effect
  useEffect(() => {
    socket.emit(C.CREDIT, encode({ coin: storage.getKey('coin') || "BTC" }));
    socket.on(C.CREDIT, (data) => getCreditAndCoins(decode(data)));

    socket.on("deposit_archive", showArchive);

    wait(400).then(() => {
      loadCoinId(storage.getKey('coin') || "BTC");
    });

    return () => {
      socket.off(C.CREDIT);
    };
  }, [storage.getKey('coin') || "BTC", getCreditAndCoins, loadCoinId, showArchive]);

  // Sync selectedCoin with SkylaCredit via coin_changed event
  useEffect(() => {
    const handleCoinChanged = (coinName) => {
      setSelectedCoin(coinName); // Update selectedCoin when coin changes in SkylaCredit
      setState(prev => ({ ...prev, currentCoin: coinName })); // Update state.currentCoin
      loadCoinId(coinName); // Load coin details for the new coin
    };

    socket.on('coin_changed', handleCoinChanged);

    // Initialize with stored coin
    const storedCoin = storage.getKey('coin') || "BTC";
    setSelectedCoin(storedCoin);
    setState(prev => ({ ...prev, currentCoin: storedCoin }));
    loadCoinId(storedCoin);


  }, [loadCoinId]);

  // Active Coins Initialization Effect
  useEffect(() => {
    if (!storage.getKey('active_coins')) {
      const defaultActiveCoins = ['1', '2', '3', '4', '5', '6', '7'];
      storage.setKey('active_coins', defaultActiveCoins.join(','));
      setActiveCoins(defaultActiveCoins);
    }
  }, []);

  // Click Outside Handler Effect
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.dropdown-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const handleCoinSelect = async (coinName) => {
    setSelctedNetwork('')
    setState(prev => ({
      ...prev,

      coinId: "",
      networks: [],
      selectedNetwork: "",

      coinName: "",
      logoUrl: ""
    }));
    setCCInititate(false)
    if (storage.getKey('coin') === coinName) {
      setIsOpen(false);
      return;
    }

    storage.setKey('coin', coinName);
    const credit = forceSatoshiFormat(credits[__.lowerCase(coinName)] || 0);
    storage.setKey('credit', credit);

    setSelectedCoin(coinName);
    loadCoinId(coinName)
    setIsOpen(false);

    try {
      await wait(200);
      Event.emit('coin_changed', coinName);
    } catch (error) {
      console.error('Error during coin selection:', error);
    }
  };

  const filteredCoins = coins
    .filter(coin => {
      if (!activeCoins.includes(coin.id.toString())) return false;
      // Exclude BJT and SC from the filtered list
      if (coin.preffix === 'BJT' || coin.preffix === 'SC') return false; // Exclude BJT and SC
      // Admin-created users only see INR (manual payment only)
      if (isAdminCreatedUser && coin.preffix !== 'INR') return false;
      return coin.preffix.toLowerCase().includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => {
      if (a.preffix === 'BTC') return -1;
      if (b.preffix === 'BTC') return 1;
      return 0;
    });

  const selectedCoinData = coins.find(coin => coin.preffix === selectedCoin);
  //statically netwrosk added later will remove it
  const networkDetails = [
    "Etherum", "BEP20"
  ]
  const handleUPISelect = (upiType) => {
    setSelectedUPI(upiType);
    // Additional logic for UPI selection can be added here
  };
  const handleUPI1Payment = async () => {



    if (!state.amount || parseFloat(state.amount) < 300) {
      sendNotfication("Please enter an amount equal to or greater than ₹300.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post(`${API}/remotes/create-deposit`, {
        amount: state.amount,
        currency: 'INR',
        custom_user_id: getUID(),
        custom_transaction_id: `TX_${Date.now()}`,
        payment_system: "phonepe",
        webhook_id: 2472417,
        return_url: 'https://bkk07.com/',
      });

      const { success, url, order_id } = response.data;

      if (success) {
        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: order_id,
          isLoading: false,
          iframeUrl: url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 300) {
        sendNotfication("Please enter amount equal to or greater than ₹300.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleIMPSPayment = async () => {
    if (!state.amount || parseFloat(state.amount) < 300) {
      sendNotfication("Please enter an amount equal to or greater than ₹300.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post(`${API}/remotes/create-deposit`, {
        amount: state.amount,
        currency: 'INR',
        custom_user_id: getUID(),
        custom_transaction_id: `TX_${Date.now()}`,
        payment_system: "imps",
        webhook_id: 2472417,
        return_url: 'https://bkk07.com',
      });

      const { success, url, order_id } = response.data;

      if (success) {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: order_id,
          isLoading: false,
          iframeUrl: url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 300) {
        sendNotfication("Please enter amount equal to or greater than ₹300.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };



   const handleUPI3Payment = async () => {
    if (!state.amount || parseFloat(state.amount) < 1000) {
      sendNotfication("Please enter an amount equal to or greater than ₹1000.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const name = localStorage.getItem("name");
      let id = getUID();
      const response = await axios.post(`${API}/cricpay/payment-request`, {
        amount: state.amount,
        userId: id,
       paymentMethod: "PS002",
       userName: "jhonSon"
      });

   
      const { status, accessURL, transactionCode } = response.data;

      if (status==="Success") {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: transactionCode,
          isLoading: false,
          iframeUrl: accessURL, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 1000) {
        sendNotfication("Please enter amount equal to or greater than ₹1000.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

   const handleNetBankingPayment = async () => {
    if (!state.amount || parseFloat(state.amount) < 1000) {
      sendNotfication("Please enter an amount equal to or greater than ₹1000.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const name = localStorage.getItem("name");
      let id = getUID();
      const response = await axios.post(`${API}/cricpay/payment-request`, {
        amount: state.amount,
        userId: id,
        paymentMethod: "PS003",
        userName: "jhonSon"
      });

      const { status, accessURL, transactionCode } = response.data;

      if (status==="Success") {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: transactionCode,
          isLoading: false,
          iframeUrl: accessURL, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 1000) {
        sendNotfication("Please enter amount equal to or greater than ₹1000.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };
  const [upiMethod, setUpiMethod] = useState('upi1');

  const handleUPI2Payment = async () => {
    console.log(`Proceeding with UPI2 and phone ${phoneNumber}`);

    if (!state.amount || parseFloat(state.amount) < 100) {
      sendNotfication("Please enter an amount equal to or greater than ₹200.", "error", "top-right");
      return;
    }

    if (!phoneNumber || phoneNumber.length < 10) {
      sendNotfication("Please enter a valid phone number.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post(`${API}/api/payments/payin/initiate`, {
        userId: getUID(), // Assuming getUID() is your user ID
        currency: "INR",
        out_trade_no: `TX${Date.now()}`, // Generate unique transaction ID
        pay_type: "UPI",
        money: state.amount,
        attach: "",
        notify_url: `${API}/api/payments/payin/callback`,
        returnUrl: "https://bkk07.com",
        phone: phoneNumber
      });

      const { code, data } = response.data;

      if (code === 0) {
        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: data.transaction_Id,
          isLoading: false,
          iframeUrl: data.url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));
      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating UPI payment:", error);
      if (!state.amount || parseFloat(state.amount) < 100) {
        sendNotfication("Please enter amount equal to or greater than ₹100.", "error", "top-right");
      } else {
        sendNotfication("Enter valid phone number", "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleSubmitTransactionFiat = async () => {
    if (!transactionId || !screenshot) {
      setError("Please fill all required fields");
      return;
    }

    if (!state.amount || parseFloat(state.amount) <= 0) {
      setError("Please enter a valid amount");
      return;
    }

    try {
      const formData = new FormData();

      // Use the fields required by your API
      formData.append('user_id', getUID());
      formData.append('amount', state.amount);
      formData.append('transaction_id', transactionId);
      formData.append('screenshot', screenshot);
      formData.append('currency', selectedCoin);
      // Add bank details if selected payment is Bank Transfer
      if (selectedPayment === "Bank Transfer") {
        formData.append('bank_name', selectedBank);
        formData.append('account_number', bankDetails.accountNumber);
        formData.append('ifsc_code', bankDetails.ifscCode);
        formData.append('account_holder_name', bankDetails.accountName);
      }
      // Add UPI details if selected payment is UPI
      else if (selectedPayment === "UPI ID") {
        formData.append('upi_id', '993939393@upi');
      }

      const response = await axios.post(`${API}/api/deposits/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        sendNotfication("Deposit request created successfully", "success", "top-right");
        setShowTransactionForm(false);
        setTransactionId("");
        setScreenshot(null);
        setCCInititate(false);
        setState(prev => ({ ...prev, amount: "" }));
      } else {
        setError(response.data.message || "Failed to submit deposit request");
        sendNotfication(response.data.message || "Failed to submit deposit request", "error", "top-right");
      }
    } catch (error) {
      console.error("Error submitting transaction:", error);
      const errorMessage = error.response?.data?.message || "Failed to submit deposit request";
      setError(errorMessage);
      sendNotfication(errorMessage, "error", "top-right");
    }
  };
  const handleDeposit = () => {
    if (!state.amount) {
      setError("Please enter deposit amount");
      return;
    }

    if (isFiatCurrency(selectedCoin)) {
      if (paymentMode === 'automatic' && selectedCoin === 'INR') {
        // Use existing automatic payment for INR
        handleUPI1Payment();
      } else {
        // For all other fiat currencies or manual INR payments, 
        // show transaction form for manual payments
        setShowTransactionForm(true);
      }
    } else {
      // For crypto deposits
      initiateDeposit();
    }
  };
  const renderINRSpecificFields = () => {


    if (selectedCoin === 'INR') {
      return (
        <PaymentMethodContainer>
          <DepositButton
            onClick={() => {
              setPaymentMode('manual');
              setShowTransactionForm(true);
              setCCInititate(true);
            }}
          >
            Manual Payment
          </DepositButton>
        </PaymentMethodContainer>
      );
    } else if (isFiatCurrency(selectedCoin)) {
      return (
        <PaymentMethodContainer>
          <MethodSelector>
            <MethodButton
              selected={true}
              onClick={() => setPaymentMode('automatic')}
            >
              Automatic Payment
            </MethodButton>
          </MethodSelector>

          {/* UPI Method Selector */}
          <MethodSelector style={{ marginTop: '10px' }}>
            <MethodButton
              selected={upiMethod === 'upi1'}
              onClick={() => setUpiMethod('upi1')}
            >
              UPI 1
            </MethodButton>
            <MethodButton
              selected={upiMethod === 'upi2'}
              onClick={() => setUpiMethod('upi2')}
            >
              UPI 2
            </MethodButton>
            <MethodButton
              selected={upiMethod === 'upi3'}
              onClick={() => setUpiMethod('upi3')}
            >
              UPI 3
            </MethodButton>
            <MethodButton
              selected={upiMethod === 'imps'}
              onClick={() => setUpiMethod('imps')}
            >
              IMPS
            </MethodButton>
            <MethodButton
              selected={upiMethod === 'netbanking'}
              onClick={() => setUpiMethod('netbanking')}
            >
              Netbanking
            </MethodButton>
          </MethodSelector>

          {upiMethod === 'upi2' && (
            <Input
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter Phone Number"
              style={{ marginTop: '10px' }}
            />
          )}

          <DepositButton
            onClick={upiMethod === 'upi1' ? handleUPI1Payment :
              upiMethod === 'imps' ? handleIMPSPayment :
              upiMethod === 'upi3' ? handleUPI3Payment :
              upiMethod === 'netbanking' ? handleNetBankingPayment :
                handleUPI2Payment}
          >
            Proceed to Automatic Payment
          </DepositButton>
        </PaymentMethodContainer>
      );
    } else {
      // For crypto currencies
      return (
        !ccInitiate ?
          <DepositButton onClick={initiateDeposit}>
            Proceed with Deposit
          </DepositButton>
          : <></>
      );
    }
  };


  const FIAT_CURRENCIES = {
    INR: {
      payType: 'UPI',
      automatic: true,
      manual: true
    },
    MVR: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    PKR: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    AED: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    BDT: {
      payType: 'Bank',
      automatic: false,
      manual: true
    }
  };

  const isFiatCurrency = (currency) => {
    return Object.keys(FIAT_CURRENCIES).includes(currency);
  };

  // Add an effect to listen for coin_changed events
  useEffect(() => {
    const handleCoinChanged = (coinName) => {
      console.log("Coin changed event received in DepositModal:", coinName);
      setSelectedCoin(coinName);
      loadCoinId(coinName);
    };

    Event.on('coin_changed', handleCoinChanged);

    // Initialize with the coin from storage on component mount
    const storedCoin = storage.getKey('coin');
    if (storedCoin) {
      setSelectedCoin(storedCoin);
      loadCoinId(storedCoin);
    }

    return () => {
      // Event.off('coin_changed', handleCoinChanged);
    };
  }, [loadCoinId]);

  return (
    <Container>


      <TokenListContainer>
        {!isAdminCreatedUser && tokens.map(token => (
          <TokenButton key={token.id}>
            <TokenIcon src={token.icon} alt={`${token.name} icon`} />
            <TokenName>{token.name}</TokenName>
          </TokenButton>
        ))}
      </TokenListContainer>
      {/* 
      <FooterText>
        Didn't see your currency? <AddLink>Add here</AddLink>
      </FooterText> */}

      {
        paymentMode === "automatic" && selectedCoin === "INR" ? (<div style={{ display: "flex", gap: "5px", width: "100%" }}>
          <div style={{ flex: '1' }}>
            <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Deposit Currency</div>
            <DropdownContainer>
              <DropdownButton onClick={(e) => {
                e.stopPropagation();
                setIsOpen(!isOpen);
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <CoinImage
                    src={`/assets/images/${selectedCoinData?.image}`}
                    alt={selectedCoin}
                  />
                  <CoinName>{selectedCoin}</CoinName>
                </div>
                <ChevronDown size={20} />
              </DropdownButton>

              {isOpen && (
                <DropdownPanel onClick={e => e.stopPropagation()}>
                  <SearchContainer>
                    <SearchIcon>
                      <Search size={20} />
                    </SearchIcon>
                    <SearchInput
                      placeholder="Search coins..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      autoFocus
                    />
                  </SearchContainer>

                  {filteredCoins.map((coin) => (
                    <CoinOption
                      key={coin.id}
                      onClick={() => handleCoinSelect(coin.preffix)}
                      isSelected={selectedCoin === coin.preffix}
                    >
                      <CoinImage src={`/assets/images/${coin.image}`} alt={coin.preffix} />
                      <CoinName>{coin.preffix}</CoinName>
                      <CoinBalance>
                        {forceSatoshiFormat(credits[__.lowerCase(coin.preffix)] || 0)}
                      </CoinBalance>
                    </CoinOption>
                  ))}
                </DropdownPanel>
              )}
            </DropdownContainer>
          </div>
        </div>) : (
          <div style={{ display: "flex", gap: "5px", width: "100%" }}>
            <div style={{ flex: '1' }}>
              <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Deposit Currency</div>
              <DropdownContainer>
                <DropdownButton onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(!isOpen);
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <CoinImage
                      src={`/assets/images/${selectedCoinData?.image}`}
                      alt={selectedCoin}
                    />
                    <CoinName>{selectedCoin}</CoinName>
                  </div>
                  <ChevronDown size={20} />
                </DropdownButton>

                {isOpen && (
                  <DropdownPanel onClick={e => e.stopPropagation()}>
                    <SearchContainer>
                      <SearchIcon>
                        <Search size={20} />
                      </SearchIcon>
                      <SearchInput
                        placeholder="Search coins..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                      />
                    </SearchContainer>

                    {filteredCoins.map((coin) => (
                      <CoinOption
                        key={coin.id}
                        onClick={() => handleCoinSelect(coin.preffix)}
                        isSelected={selectedCoin === coin.preffix}
                      >
                        <CoinImage src={`/assets/images/${coin.image}`} alt={coin.preffix} />
                        <CoinName>{coin.preffix}</CoinName>
                        <CoinBalance>
                          {forceSatoshiFormat(credits[__.lowerCase(coin.preffix)] || 0)}
                        </CoinBalance>
                      </CoinOption>
                    ))}
                  </DropdownPanel>
                )}
              </DropdownContainer>
            </div>

            {
              isFiatCurrency(selectedCoin) ? (

                <div style={{ flex: '1' }}>
                  {/* Show for other fiat and crypto coins as usual */}
                  <>
                    <div style={{ color: "#B3BEC1", margin: "4px 0" }}>
                      {isFiatCurrency(selectedCoin) ? "Choose Bank" : "Choose Network"}
                    </div>
                    <DropdownContainer>
                      <DropdownButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsOpenNetwork(!isOpenNetwork);
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <CoinName>{selectedBank || (bankDetails.length > 0 ? bankDetails[0].bank_name : (isFiatCurrency(selectedCoin) ? "Select Bank" : "Select Network"))}</CoinName>
                        </div>
                        <ChevronDown size={20} />
                      </DropdownButton>

                      {isOpenNetwork && (
                        <DropdownPanel onClick={(e) => e.stopPropagation()}>
                          {bankDetails.map((bank) => (
                            <CoinOption
                              key={bank.id}
                              onClick={() => handleBankSelect(bank.bank_name)}
                              isSelected={selectedBank === bank.bank_name}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <CoinName>{bank.bank_name}</CoinName>
                              </div>
                            </CoinOption>
                          ))}
                        </DropdownPanel>
                      )}
                    </DropdownContainer>
                  </>
                </div>

              ) :
                (
                  <>
                    {
                      state.networks?.length > 0 && (
                        <div style={{ flex: '1' }}>
                          <div style={{ color: "#B3BEC1", margin: "4px 0" }}>
                            Choose Network
                          </div>
                          <DropdownContainer>
                            <DropdownButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpenNetwork(!isOpenNetwork);
                              }}
                            >
                              <CoinName>{selectedNetwork}</CoinName>
                              <ChevronDown size={20} />
                            </DropdownButton>

                            {isOpenNetwork && (
                              <DropdownPanel onClick={e => e.stopPropagation()}>
                                {state?.networks?.map((network) => (
                                  <CoinOption
                                    key={network}
                                    onClick={() => {
                                      setSelctedNetwork(network)
                                      setIsOpenNetwork(false);
                                    }}
                                    isSelected={selectedNetwork === network}
                                  >
                                    <CoinName>{network}</CoinName>
                                  </CoinOption>
                                ))}
                              </DropdownPanel>
                            )}
                          </DropdownContainer>
                        </div>
                      )
                    }
                  </>
                )
            }
          </div>
        )
      }

      {
        state?.isLoading ?
          <SpinnerWrapper className="p-4">
            <Spinner />
            <LoadingText>Loading</LoadingText>
          </SpinnerWrapper>
          : (
            <>

              {
                ccInitiate && (
                  <CodeContainer>
                    {isFiatCurrency(selectedCoin) ? (
                      <>
                        <QRCodeContainer>
                          {selectedCoin === "INR" && selectedBankDetails.qr_image ? (
                            <img src={`data:image/png;base64,${selectedBankDetails.qr_image}`} alt="QR Code" />
                          ) : null}
                            
                        </QRCodeContainer>


                        <ContentContainer>
                          {/* <Label>
                            {selectedBank ? `${selectedBank} Bank Details` : "Bank Details"}
                          </Label> */}

                          {selectedBankDetails.accountName && (
                            <AddressContainer>
                              <span>Account Holder Name: {selectedBankDetails.accountName}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('accountName', selectedBankDetails.accountName)}
                                copied={copiedStates.accountName}
                              >
                                {copiedStates.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails.accountNumber && (
                            <AddressContainer>
                              <span>Account Number: {selectedBankDetails.accountNumber}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('accountNumber', selectedBankDetails.accountNumber)}
                                copied={copiedStates.accountNumber}
                              >
                                {copiedStates.accountNumber ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails.ifscCode && (
                            <AddressContainer>
                              <span>IFSC Code: {selectedBankDetails.ifscCode}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('ifscCode', selectedBankDetails.ifscCode)}
                                copied={copiedStates.ifscCode}
                              >
                                {copiedStates.ifscCode ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails.upiId && (
                            <AddressContainer>
                              <span>UPI ID: {selectedBankDetails.upiId}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('upiId', selectedBankDetails.upiId)}
                                copied={copiedStates.upiId}
                              >
                                {copiedStates.upiId ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}
                        </ContentContainer>
                      </>
                    ) : (
                      <>
                        <QRCode
                          size={150}
                          logoWidth={150}
                          value={state.qrString}
                        />

                        <ContentContainer>
                          <Label>Deposit address</Label>
                          <AddressContainer>
                            <span>{state.depositAddress}</span>
                            <CopyButton onClick={handleCopy}>
                              {copied ? <CheckCircle size={18} /> : <Copy size={18} />}
                            </CopyButton>
                          </AddressContainer>
                        </ContentContainer>
                      </>
                    )}
                  </CodeContainer>
                )
              }
            </>
          )
      }
      <div style={{ display: "flex", gap: "10px", width: "100%", flexDirection: 'column', marginTop: "10px" }}>
        <Input
          value={state.amount}
          onChange={(e) => {
            const newAmount = e.target.value;
            setState((prev) => ({ ...prev, amount: newAmount }));

            // Clear error when input changes
            setError("");

            // Check for MVR minimum amount while typing
            if (state.currentCoin === "MVR" && newAmount !== "" && Number(newAmount) < 100) {
              setError("Minimum deposit for MVR is 100");
            }
          }}
          placeholder={placeholder}
        />
        {error && <ErrorText>{error}</ErrorText>}
        {renderINRSpecificFields()}

        {showTransactionForm ? (
          <TransactionForm>
            <Input
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              placeholder="Enter Transaction/UTR Number"
            />
            <FileUploadContainer onClick={() => document.getElementById('fileInput').click()}>
              <Upload size={24} color="#41ED84" />
              <UploadText>{screenshot ? screenshot.name : 'Upload Payment Screenshot'}</UploadText>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
            </FileUploadContainer>
            <DepositButton onClick={handleSubmitTransactionFiat}>
              Submit
            </DepositButton>
          </TransactionForm>
        ) : (
          !isFiatCurrency(selectedCoin) && (
            // <DepositButton onClick={handleDeposit}>
            //   {selectedCoin === 'MVR' ? 'Proceed to Payment' : 'Deposit'}
            // </DepositButton>
            <div></div>
          )
        )}
      </div>


      {isOpenBonus && (
        <RadioContainer>
          {deposits.map((deposit, index) => (
            <Label3 key={index}>
              <RadioWrapper>
                <HiddenRadio
                  type="radio"
                  name="deposit"
                  value={deposit}
                  checked={selectedDeposit === deposit}
                  onChange={(e) => setSelectedDeposit(e.target.value)}
                />
                <CustomRadio />
              </RadioWrapper>
              <Text>{deposit}<span style={{ color: "rgb(67,236,131)", fontFamily: 'none', marginLeft: '4px', fontSize: '14px', fontWeight: 'bold' }}>{getTextBonus(index)}</span></Text>
            </Label3>
          ))}
        </RadioContainer>
      )}
      <div style={{ margin: "12px 0" }}>
        <WarningContainer>
          <Info color="#ab1ac6" />
          <WarningText>Do not deposit any currency other than {selectedCoin}</WarningText>
        </WarningContainer>

        {/* Add the new note container right here */}
        <NoteContainer>
          <NoteIcon size={20} />
          <NoteText>
            Usually deposits are instant but in some cases {selectedCoin === "INR" ? "INR" : selectedCoin} deposits can take up to 2hrs.
            If you haven't received your deposit amount, please contact customer support.
          </NoteText>
        </NoteContainer>
      </div>
      {state.showIframe && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '600px',
              height: '600px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <button
              onClick={() => {
                setState((prev) => ({ ...prev, showIframe: false, iframeUrl: '' }));
                window.location.reload();
              }}
              style={{
                position: 'absolute',
                top: '12px',
                left: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: '50%',
                padding: '10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                transition: 'background-color 0.2s, transform  reman 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)')}
              onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
              onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              aria-label="Back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#333"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <iframe
              src={state.iframeUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="UPI Payment"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </div>
        </div>
      )}
    </Container>
  );
};

export default SkylaDepositModal;



